import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';

const defaultFilter = { status: 'any', sort: 'createdAt' };

const loadEpisodes = (filter) => {
  const query = qs.stringify(_.defaults(filter, defaultFilter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/episodes${query}`);
  }
  return axiosAPI.get('/episodes?status=any');
};

const loadEpisodeById = (episodeId) => {
  return axiosAPI.get(`/episodes/${episodeId}?showEditor=any`);
};

const createEpisode = (body) => {
  return axiosAPI.post('/episodes', body);
};

const updateEpisodeById = (episodeId, newEpisode) => {
  return axiosAPI.put(`/episodes/${episodeId}`, newEpisode);
};

const deleteEpisode = (episodeId) => {
  return axiosAPI.delete(`/episodes/${episodeId}`, episodeId);
};

const loadTpbsEpisodes = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axiosAPI.get(`/integrations/thaipbs-program/episodes${query}`);
};

const importEpisodes = (body) => {
  return axiosAPI.post('/import/episodes', body);
};

// For Modals
const loadEpisodesByPage = (page) => {
  let url = '/episodes?limit=5';
  if (page) {
    url += `&page=${page}`;
  }
  return axiosAPI.get(url);
};

const searchEpisodesInsideModal = (name) => {
  return axiosAPI.get(`/episodes?limit=5&q=${name}`);
};

export {
  loadEpisodes,
  loadEpisodeById,
  updateEpisodeById,
  createEpisode,
  deleteEpisode,
  loadEpisodesByPage,
  loadTpbsEpisodes,
  searchEpisodesInsideModal,
  importEpisodes,
};
